/* eslint-disable */
// @ts-nocheck
import { ghb } from "@cervval.js/i18n/src/i18n.tools";

export const i18n = {
    noDataPlaceholder: "Aucune donnée",
    noSelectedValuePlaceholder: {
        default: "Sélectionner une valeur",
        plural: "Sélectionner des valeurs"
    }
};